import Component from '@glimmer/component';
import RouteTemplate from 'ember-route-template';
import BannerComponent from '../../components/layout/banner/main';
import LiveNewsTicker from '../../components/layout/live-news-ticker';
import { pageTitle } from 'ember-page-title';
import { LinkTo } from '@ember/routing';
import { eq } from '../../helpers/article-type';

class GameComponent extends Component {
  <template>
    {{#if @model}}
      {{pageTitle (if @model.title @model.title @model.name)}}
      <BannerComponent @theme='gaming' @title='{{if @model.title @model.title @model.name}}' />
      <LiveNewsTicker />
      
      <div class='layout-content-1 layout-item-3-1 grid-limit gutter-big'>
        <div class='layout-body layout-item'>
          <div class='widget-item'>
            <div class='game-header'>
              {{#if @model.image}}
                <div class='game-image-wrap'>
                  <img class='game-image' src='{{@model.image.url}}' alt='{{if @model.title @model.title @model.name}}' />
                </div>
              {{/if}}
              
              <div class='game-info'>
                <h1 class='game-title'>{{if @model.title @model.title @model.name}}</h1>
                {{#if @model.subTitle}}
                  <p class='game-subtitle'>{{@model.subTitle}}</p>
                {{/if}}
                
                {{#if @model.description}}
                  <div class='game-description'>
                    <p>{{@model.description}}</p>
                  </div>
                {{/if}}
                
                {{#if @model.purchaseLink}}
                  <div class='game-actions'>
                    <a href='{{@model.purchaseLink}}' target='_blank' rel='noopener noreferrer' class='btn btn-primary btn-large'>
                      {{#if (eq @model.price "Free-to-Play")}}
                        Play Free Now
                      {{else if (eq @model.price "Free")}}
                        Play Free Now
                      {{else}}
                        Get Game
                      {{/if}}
                    </a>
                  </div>
                {{/if}}
              </div>
            </div>
            
            <div class='game-details-section'>
              <div class='section-title-wrap gaming'>
                <h2 class='section-title medium'>Game Details</h2>
                <div class='section-title-separator'></div>
              </div>
              
              <div class='game-details-grid'>
                {{#if @model.releaseDate}}
                  <div class='game-detail-item'>
                    <p class='game-detail-label'>Release Date</p>
                    <p class='game-detail-value'>{{@model.releaseDate}}</p>
                  </div>
                {{/if}}
                
                {{#if @model.price}}
                  <div class='game-detail-item'>
                    <p class='game-detail-label'>Price</p>
                    <p class='game-detail-value'>{{@model.price}}</p>
                  </div>
                {{/if}}
                
                {{#if @model.availableInOurStore}}
                  <div class='game-detail-item'>
                    <p class='game-detail-label'>Availability</p>
                    <p class='game-detail-value'>
                      {{#if @model.availableInOurStore}}
                        Available in Store
                      {{else}}
                        External Purchase
                      {{/if}}
                    </p>
                  </div>
                {{/if}}
              </div>
            </div>
          </div>
          
          <div class='back-to-games'>
            <LinkTo @route='games.index' class='btn btn-secondary'>
              ← Back to All Games
            </LinkTo>
          </div>
        </div>
      </div>
      
      <style>
        .game-overview {
          display: flex;
          gap: 2rem;
          margin-bottom: 2rem;
        }
        
        .game-logo-wrap {
          flex-shrink: 0;
        }
        
        .game-logo {
          width: 120px;
          height: 120px;
          object-fit: cover;
          border-radius: 8px;
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
        }
        
        .game-info-wrap {
          flex: 1;
        }
        
        .game-description {
          margin-bottom: 1.5rem;
        }
        
        .game-description p {
          font-size: 1.1rem;
          line-height: 1.6;
          color: #666;
        }
        
        .game-details-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
          gap: 1rem;
        }
        
        .game-detail-item {
          background: #f8f9fa;
          padding: 1rem;
          border-radius: 6px;
          border-left: 3px solid #7442ce;
        }
        
        .game-detail-label {
          font-size: 0.9rem;
          font-weight: 600;
          color: #7442ce;
          margin-bottom: 0.25rem;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }
        
        .game-detail-value {
          font-size: 1rem;
          font-weight: 500;
          color: #333;
        }
        
        .back-to-games {
          margin-top: 2rem;
        }
        
        .btn {
          display: inline-block;
          padding: 0.75rem 1.5rem;
          text-decoration: none;
          border-radius: 6px;
          font-weight: 500;
          transition: all 0.2s ease;
        }
        
        .btn-secondary {
          background: #6c757d;
          color: white;
        }
        
        .btn-secondary:hover {
          background: #5a6268;
          transform: translateY(-1px);
        }
        
        @media (max-width: 768px) {
          .game-overview {
            flex-direction: column;
            text-align: center;
          }
          
          .game-details-grid {
            grid-template-columns: 1fr;
          }
        }
      </style>
    {{else}}
      {{pageTitle 'Game Not Found'}}
      <BannerComponent @theme='gaming' @title='Game Not Found' />
      <LiveNewsTicker />
      
      <div class='layout-content-1 layout-item grid-limit gutter-big'>
        <div class='widget-item text-center'>
          <h2>Game Not Found</h2>
          <p>Sorry, we couldn't find the game you're looking for.</p>
          <LinkTo @route='games.index' class='btn btn-primary'>
            Browse All Games
          </LinkTo>
        </div>
      </div>
    {{/if}}
  </template>
}

export default RouteTemplate(GameComponent);
